import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Note: StrictMode removed to prevent double OTP sends in development
// In React 18, StrictMode double-invokes effects which causes duplicate API calls
root.render(
  <App />
);
